import React, { Component } from 'react'
import Links from './components/partials/Links_Container'

export default class AssistiveReader extends Component {
    render() {
        return (
            <section className="page-content" id="page-brackets">
                <Links />
                <div className="app_container" id="softSpoke_container">
                    <div className="app-title">SoftSpoke<p className="subtitle">Assistive Reader</p><a href="https://softspoke.herokuapp.com">Try it &#10132;</a></div>
                    <img id="hero" src="/images/brackets/softspoke/preview2.jpg" alt=""/>
                    <p className="app-description">Helping others to read more easily, Assistive Reader takes text and gives users an intative way to control the text they're reading. The reader takes any English text and applies real-time <em>Parts of Speech</em> tagging, word frequencies, and highlighting. Take it a step further, listen and follow along with the text with your systems' own text-to-speech synthesizer. SoftSpoke hopes to increase reading comprehension and give agency to readers everywhere.</p>
                    <div className="app-item app-meta" id="softspoke-meta">
                        <img src="/images/brackets/softspoke/preview3.jpg" id="" alt="Assistive Reader, Settings"/> 
                        <ul>
                            <li>HTML5 CSS3 Compromise.js</li>
                            <li>EJS6 Speech-Synthesis-API</li>
                            <li>React.js Redux</li>
                            <li>node.js express</li>
                        </ul>
                    </div>
					<div className="app-item" id="softSpoke-splash">
						<video autoPlay="autoplay" loop="loop" muted>
							<source src="/images/brackets/softspoke/softspoke-ar.mp4" type="video/mp4"/>
							Unfortuneately, Your browser does not support this video format.
						</video> 
						<div className="video-filter"></div>                        
                        <p>SoftSpoke is a start-up creating a platform of tools to assist in reading, communicating, and learning for everyone. Assistive Reader was made using accessible technologies to give users a better interface to their reading content. <a href="http://compromise.cool/" target="_blank">CompromiseJS</a> is a lightweight and incredibly capable natural language processing library which adds contextual, meta, and grammar tools to the text.</p>
					</div>
                    <div className="app-item app-row" id="softSpoke-features">
                        <img src="/images/brackets/softspoke/settings.jpg" alt=""/>						
                        <div>
                            <h3>Features</h3>
                            <ul>
                                <li>Text modification (font type, size, spaceing, colour)</li>
                                <li>Parts-of-Speech tagging</li>
                                <li>Text-to-Speech and word highlighting</li>
                                <li>Word frequency and word find</li>
                                <li>Real-time text processing</li>
                            </ul>
                        </div>
                    </div>
                    <div className="app-item app-row" id="softSpoke-tech">
                        <div>
                            <h3>Future additions</h3>
                            <ul>
                                <li>Printable/downloadable options for added text</li>
                                <li>Distraction free mode</li>
                                <li>Background color change/Dark Mode</li>
                                <li>Dyslexic font integration</li>
                                <li>Text to Speech voice options</li>
                                <li>Increased parts of speech tagging</li>
                                <li>More text meta-data</li>
                                <li>Word completion</li>
                            </ul>
                        </div>
                        <img src="/images/brackets/softspoke/preview.jpg" alt=""/>
                    </div>
                </div>
            </section>
        )
    }
}
